import { Suspense, lazy } from 'react'
import type { ComponentProps } from 'react'
import Loader from '@/components/Loader'

const MarkdownEditor = lazy(() => import('@/components/MarkdownEditor'))

export type LazyMarkdownEditorProps = ComponentProps<typeof MarkdownEditor>

export default function LazyMarkdownEditor(props: LazyMarkdownEditorProps) {
  return (
    <Suspense fallback={<Loader />}>
      <MarkdownEditor {...props} />
    </Suspense>
  )
}
